import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { RegExpUtility } from "../text/RegExpUtility";
import { CLikeLexer } from "../text/lexer/CLikeLexer";
import { LexerMatcherLibrary } from "../text/lexer/LexerMatcherLibrary";
import { LexerMatcher } from "../text/lexer/LexerMatcher";
import { ClassFlag } from "../dom-tools/ClassFlag";
import { UnityLibrary } from "../text/lexer/library/UnityLibrary";
import { GodotShader } from "../text/lexer/library/GodotShader";
import { ElementSelector } from "../dom-tools/ElementSelector";
import { AttributeValue } from "../dom-tools/AttributeValue";
import { HTMLEditor } from "../dom-tools/HTMLEditor";
import { GodotLibrary } from "../text/lexer/library/GodotLibrary";
import { TypeScriptLibrary } from "../text/lexer/library/TypeScriptLIbrary";
import { CSharpLanguage } from "../text/lexer/library/CSharpLanguage";
import { PHPLexer } from "../text/lexer/PHPLexer";
import { PHPLanguage } from "../text/lexer/library/PHPLanguage";
import { GDScriptLexer } from "../text/lexer/GDScriptLexer";
import { GDScriptLanguage } from "../text/lexer/library/GDScriptLanguage";
// import { GodotDocsIndexSelector } from "../../_rokojori.com/js/godot-docs/GodotDocsIndexSelector";
// import { GodotDocsFile } from "../../_rokojori.com/js/godot-docs/GodotDocsFile";
// import { Rokojori } from "../../_rokojori.com/js/Rokojori";

export class LexCode
{
  static readonly type = new ElementType( "lex--code" );
  static readonly language = new ElementAttribute( "language" );
  static readonly autoFormatAttribute = new ElementAttribute( "auto--format" );
  static lexer = new CLikeLexer();
  static phpLexer = new PHPLexer();
  static gdLexer = new GDScriptLexer();

  static readonly token     = new ElementType( "token--" );
  static readonly tokenType = new ElementAttribute( "type" );
  static readonly special = new ClassFlag( "special" );
  static readonly special2 = new ClassFlag( "special2" );

  static applyOnDocument()
  {
    LexCode.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static #defaultTypes = 
  /^(void|var|let|auto|object|float|int|color|bool|boolean|double|Vector3|Vector2|Vector4|using|import)$/i;

  static applyOnElement( e:Element )
  {
    let textContent = e.textContent;
    

    textContent = RegExpUtility.removeLeadingSpace( textContent );

    let lang = LexCode.language.from( e ); 

    let autoFormat = LexCode.autoFormatAttribute.in( e );

    if ( "none" === lang )
    {
      return;
    }

    let lexer = LexCode.lexer;

    if ( PHPLanguage.token == lang )
    {
      lexer = LexCode.phpLexer;
    }

    if ( GDScriptLanguage.token == lang )
    {
      lexer = LexCode.gdLexer;
    }



    var tokens = lexer.lexToList( textContent );
    var hasError = tokens.find( t => t.isError );

    e.innerHTML = "";

    if ( hasError )
    {
      e.appendChild( document.createTextNode( textContent ) );
      return;
    }

    var keywords:string[] = null;
    var keywords2:string[] = null;


    if ( PHPLanguage.token == lang )
    {
      keywords = PHPLanguage.keywords;
      keywords2 = PHPLanguage.keywords2;
    }


    if ( CSharpLanguage.token == lang )
    {
      keywords = CSharpLanguage.keywords;
    }

    if ( GDScriptLanguage.token == lang )
    {
      keywords = GDScriptLanguage.keywords;
      keywords2 = GDScriptLanguage.keywords2;
    }

    if ( UnityLibrary.token == lang )
    {
      keywords = UnityLibrary.keywords;
    }

    if ( TypeScriptLibrary.token == lang )
    {
      keywords = TypeScriptLibrary.keywords;
      keywords2 = TypeScriptLibrary.keywords2;
    }

    if ( GodotLibrary.token == lang )
    {
      keywords = GodotLibrary.keywords;
      keywords2 = GodotLibrary.keywords2;
    }

    if ( GodotShader.token == lang )
    {
      keywords = GodotShader.keywords;
      keywords2 = GodotShader.keywords2;
    }

    tokens.forEach(
      ( t )=>
      {
        let type = t.type;
        
        if ( t.isDoneOrError )
        {
          return;
        }
        
        let match = textContent.substring( t.offset, t.end );
        
        let token = LexCode.token.create( match );
        LexCode.tokenType.to( token, type );

        if ( LexerMatcherLibrary.CWORD_MATCHER.type == type ||
          LexerMatcherLibrary.PHPWORD_MATCHER.type == type || 
          PHPLexer.PHP_KEYWORD == type 
        )
        {
          if ( keywords == null && keywords2 == null )
          {
            if ( this.#defaultTypes.test( match ) ) 
            {
              LexCode.special.set( token );
            }
          }
          else if (  keywords != null && keywords.indexOf( match ) !== -1 )
          {
            LexCode.special.set( token );
          }
          else if (  keywords2 != null && keywords2.indexOf( match ) !== -1 )
          {
            LexCode.special2.set( token );
          }
        
        }

        e.appendChild( token );
      }
    );

    if ( autoFormat )
    {
      LexCode.autoFormat( e );
    }


    
    // if ( GodotLibrary.token == lang )
    // {
    //   let words = e.querySelectorAll( "[data-type=\"CWORD\"]" );

    //   words.forEach(
    //     ( w )=>
    //     {
    //       let docInfo = GodotDocsIndexSelector.getDocInfoForAll( w.textContent );

    //       if ( docInfo == null )
    //       {
    //         return;
    //       } 

    //       let el = HTMLEditor.wrapWithAnchorHref( w, GodotDocsFile.getLink( docInfo ) );

    //       console.log( "DocInfo for:", w.textContent, docInfo );

    //       Rokojori.$.resolveRootPaths( el );
    //     }
    //   )
    // }
  }

  static autoFormat( e:Element )
  {
    let bracketType = new AttributeValue( ElementAttribute.dataType, LexerMatcherLibrary.BRACKET_MATCHER.type );
    let wsType = new AttributeValue( ElementAttribute.dataType, LexerMatcherLibrary.WHITESPACE_MATCHER.type );
    let bracketsSelector = new ElementSelector( LexCode.token, bracketType );
    let brackets = bracketsSelector.queryAll( e );

    brackets.forEach(
      ( b )=>
      {
        if ( b.textContent === "(" )
        {

          let nextSibling = b.nextElementSibling;

          if ( nextSibling.textContent === ")" )
          {
            return;
          }

          let whiteSpace = LexCode.token.create( " " );
          wsType.set( whiteSpace );

          HTMLEditor.addAfter( b, whiteSpace );
        }
        if ( b.textContent === ")" )
        {

          let previousSibling = b.previousElementSibling;

          if ( previousSibling.textContent === "(" )
          {
            return;
          }

          let whiteSpace = LexCode.token.create( " " );
          wsType.set( whiteSpace );

          HTMLEditor.addBefore( whiteSpace, b );
        }
      }
    )
  }

}